export { default as Home } from './Home.js';
export { default as About } from './About.js';

export { default as Blog } from './blog/index';
export { default as BlogPost } from './blog/post';

export { default as ProjectPage } from './projects/detail';
export { default as ProjectListing } from './projects/index'


export { default as Contact } from './Contact.js';
export { default as Skills } from './Skills.js';
export { default as Error404 } from './Error404.js';



// WEBPACK FOOTER //
// ./src/pages/index.js